import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import logoMark from "@/assets/logo-mark.png";

function Logo({ size = 32 }) {
  return (
    <div className="flex items-center gap-2.5">
      <img src={logoMark} alt="Conta em Dia" width={size} height={size} style={{ width: size, height: size, objectFit: "contain" }} />
      <span style={{ fontFamily: "Sora, sans-serif", fontWeight: 700, fontSize: size * 0.55, color: "white" }}>Conta em dia</span>
    </div>
  );
}

export default function PrivacyPage() {
  const h2Class = "mt-8 text-xl font-semibold text-white";
  const pClass = "text-[#A0A0B0] mt-3 leading-relaxed";
  const ulClass = "mt-3 list-disc space-y-1 pl-5 text-[#A0A0B0]";

  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: "Sora, sans-serif" }}>
      <header className="border-b border-[#1A1A24] bg-black/95 backdrop-blur sticky top-0 z-50">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <Link to="/"><Logo size={28} /></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#6B6B7B] hover:text-white transition-colors">
            <ArrowLeft size={16} /> Voltar
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12">
        <div className="mx-auto max-w-3xl">
          <h1 className="mb-2 text-3xl font-bold tracking-tight md:text-4xl">Política de Privacidade</h1>
          <p className="mb-8 text-sm text-[#6B6B7B]">Última atualização: Abril de 2026</p>

          <div className="space-y-2">
            <p className={pClass}>
              A presente Política de Privacidade descreve como o <strong className="text-white">Conta em Dia</strong> coleta, usa, armazena e protege as informações dos usuários. Ao utilizar nossa plataforma, você concorda com os termos aqui descritos.
            </p>

            <h2 className={h2Class}>1. Informações que Coletamos</h2>
            <p className={pClass}>Coletamos as seguintes informações:</p>
            <ul className={ulClass}>
              <li><strong className="text-white">Informações de cadastro:</strong> nome, e-mail, dados de autenticação via Google</li>
              <li><strong className="text-white">Dados financeiros:</strong> receitas, despesas, categorias e metas inseridas por você</li>
              <li><strong className="text-white">Dados técnicos:</strong> endereço IP, tipo de navegador, dispositivo, cookies e dados de uso</li>
              <li><strong className="text-white">Comunicações:</strong> mensagens enviadas para nosso suporte</li>
            </ul>

            <h2 className={h2Class}>2. Como Usamos suas Informações</h2>
            <ul className={ulClass}>
              <li>Fornecer e manter a plataforma de gestão financeira</li>
              <li>Processar cálculos de projeção de saldo futuro</li>
              <li>Enviar notificações importantes sobre sua conta</li>
              <li>Personalizar sua experiência e melhorar nossos serviços</li>
              <li>Prevenir fraudes e garantir a segurança da plataforma</li>
              <li>Cumprir obrigações legais e regulatórias</li>
            </ul>

            <h2 className={h2Class}>3. Compartilhamento de Dados</h2>
            <p className={pClass}>Não vendemos seus dados pessoais. Podemos compartilhar informações apenas:</p>
            <ul className={ulClass}>
              <li>Com provedores de serviços essenciais (hospedagem, autenticação, pagamentos)</li>
              <li>Quando exigido por lei ou ordem judicial</li>
              <li>Para proteger nossos direitos legais e prevenir fraudes</li>
            </ul>

            <h2 className={h2Class}>4. Segurança dos Dados</h2>
            <ul className={ulClass}>
              <li>Criptografia SSL/TLS em todas as conexões</li>
              <li>Armazenamento criptografado em servidores seguros (Supabase — São Paulo)</li>
              <li>Controles de acesso rigorosos</li>
              <li>Monitoramento contínuo de segurança</li>
            </ul>

            <h2 className={h2Class}>5. Seus Direitos (LGPD)</h2>
            <p className={pClass}>Conforme a Lei Geral de Proteção de Dados (Lei 13.709/2018), você tem direito a:</p>
            <ul className={ulClass}>
              <li>Acessar seus dados pessoais</li>
              <li>Solicitar correção de dados incompletos ou desatualizados</li>
              <li>Solicitar exclusão dos seus dados</li>
              <li>Revogar consentimento a qualquer momento</li>
              <li>Solicitar portabilidade dos dados</li>
            </ul>
            <p className={pClass}>
              Para exercer seus direitos: <a href="mailto:privacidade@contaemdia.app" className="text-[#00E548] hover:underline">privacidade@contaemdia.app</a>
            </p>

            <h2 className={h2Class}>6. Cookies e Tecnologias de Rastreamento</h2>
            <p className={pClass}>Utilizamos cookies para:</p>
            <ul className={ulClass}>
              <li>Manter você logado na plataforma</li>
              <li>Analisar tráfego e comportamento de uso</li>
              <li>Medir eficácia de campanhas de marketing (Google Ads, Meta Ads, TikTok Ads)</li>
              <li>Melhorar a experiência do usuário</li>
            </ul>

            <h2 className={h2Class}>7. Serviços de Terceiros</h2>
            <ul className={ulClass}>
              <li><strong className="text-white">Google:</strong> autenticação e análise (Google Analytics, Google Ads)</li>
              <li><strong className="text-white">Meta:</strong> análise de campanhas (Meta Pixel)</li>
              <li><strong className="text-white">TikTok:</strong> análise de campanhas (TikTok Pixel)</li>
              <li><strong className="text-white">Supabase:</strong> hospedagem e banco de dados</li>
              <li><strong className="text-white">Stripe:</strong> processamento de pagamentos</li>
            </ul>

            <h2 className={h2Class}>8. Retenção de Dados</h2>
            <p className={pClass}>
              Mantemos seus dados pelo tempo necessário para cumprir as finalidades descritas ou conforme exigido por lei. Após encerramento da conta, alguns dados podem ser retidos por obrigações fiscais.
            </p>

            <h2 className={h2Class}>9. Alterações nesta Política</h2>
            <p className={pClass}>
              Podemos atualizar esta Política periodicamente. Notificaremos sobre alterações significativas por e-mail ou aviso na plataforma.
            </p>

            <h2 className={h2Class}>10. Contato</h2>
            <p className={pClass}>
              <strong className="text-white">E-mail:</strong>{" "}
              <a href="mailto:privacidade@contaemdia.app" className="text-[#00E548] hover:underline">privacidade@contaemdia.app</a>
            </p>

            <div className="mt-12 rounded-xl border border-[#1A1A24] bg-[#0F0F14] p-6">
              <p className="text-sm text-[#6B6B7B]">
                <strong className="text-white">Nota:</strong> Esta política foi elaborada em conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD) do Brasil. O Conta em Dia atua como controlador dos dados pessoais coletados.
              </p>
            </div>
          </div>
        </div>
      </main>

      <footer className="border-t border-[#1A1A24] bg-black mt-16">
        <div className="container mx-auto px-4 py-8">
          <p className="text-center text-sm text-[#3A3A48]">© 2026 Conta em Dia. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
}
